class HeroBanner {
  constructor(container) {
    this.container = container;
    this.slider = container.querySelector('.hero-banner__slider');
    
    if (!this.slider) return;

    this.slides = container.querySelectorAll('.hero-banner__slide');
    this.prevBtn = container.querySelector('.hero-banner__nav--prev');
    this.nextBtn = container.querySelector('.hero-banner__nav--next');
    this.dots = container.querySelectorAll('.hero-banner__dot');
    
    this.currentSlide = 0;
    this.autoRotate = container.dataset.autoRotate === 'true';
    this.changeSlidesSpeed = parseInt(container.dataset.changeSlidesSpeed) || 5000;

    this.init();
  }

  init() {
    this.showSlide(this.currentSlide);

    if (this.autoRotate) {
      setInterval(() => {
        this.nextSlide();
      }, this.changeSlidesSpeed);
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', this.nextSlide.bind(this));
    }

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', this.prevSlide.bind(this));
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.currentSlide = Number(dot.dataset.index);
        this.showSlide(this.currentSlide);
      });
    });
  }

  showSlide(index) {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }

  nextSlide() {
    this.currentSlide++;
    if (this.currentSlide >= this.slides.length) {
      this.currentSlide = 0;
    }
    this.showSlide(this.currentSlide);
  }

  prevSlide() {
    this.currentSlide--;
    if (this.currentSlide < 0) {
      this.currentSlide = this.slides.length - 1;
    }
    this.showSlide(this.currentSlide);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const banners = document.querySelectorAll('.hero-banner');
  banners.forEach(banner => {
    // Only initialize if there is more than 1 slide
    if (banner.querySelectorAll('.hero-banner__slide').length > 1) {
      new HeroBanner(banner);
    }
  });
});
 